import TypeIcon from "@components/Location/TypeIcon";

export interface PlaceParams extends be.LocationPrediction {
  final: string;
  locations?: be.Location[];
}

function SearchMeta({ title }: { title: string }) {
  return (
    <div className="flex items-center justify-center -mb-1 -mt-1">
      <div>
        <p className="m-0 text-gray-500 font-thin text-base">{title}</p>
      </div>
    </div>
  );
}

export function Place({
  final,
  title,
  description,
  source,
  type,
  typestring,
}: PlaceParams): JSX.Element {
  if (source == "searchMeta") {
    return <SearchMeta title={title} />;
  } else if (source == "title") {
    return (
      <div className="px-4 pt-2 mt-4">
        <div className="flex">
          <div className="text-base flex">
            <span className="font-bold text-lg grow hover:underline">{title}</span>
          </div>
        </div>
      </div>
    );
  } else if (source == "fixedHeader") {
    return (
      <div className="-mb-4">
        <span className="text-base font-bold">{title}</span>
      </div>
    );
  } else if (source == "universalLocation") {
    return (
      <div className={`relative flex items-center px-4 mt-1 mb-1 ${final == "true" ? "mb-4" : ""}`}>
        <TypeIcon typeKey={type} type={typestring} className="h-4 w-4 mr-4 flex-none" />
        <div className="flex flex-wrap items-end">
          <p className="m-0 text-base flex flex-wrap items-end">
            <span className="pr-2">{title}</span>
            <span className=" whitespace-nowrap font-thin text-gray-600 text-sm">
              {description}
            </span>
          </p>
        </div>
      </div>
    );
  } else if (source == "fixedHudson") {
    return (
      <div className={`relative flex items-center py-2`}>
        <div className="bg-white rounded-xl mr-4 ">
          <TypeIcon typeKey={type} type={typestring} className="h-6 w-6 flex-none" />
        </div>

        <div className="flex flex-wrap items-end">
          <p className="m-0 text-base flex flex-wrap items-end">
            <span className="pr-2 font-medium">{title}</span>
            <span className=" whitespace-nowrap font-thin  text-sm">{description}</span>
          </p>
        </div>
      </div>
    );
  } else if (source == "fixed") {
    return (
      <div className="py-1">
        <div className="flex">
          <div className="text-base flex items-center">
            <TypeIcon typeKey={type} type={typestring} className="h-4 w-4 mr-4 flex-none" />
            <span className="grow hover:underline ">{title}</span>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={`relative flex items-center px-4 mt-2 mb-3 ${final == "true" ? "mb-4" : ""}`}>
        {final == "true" && (
          <img
            className="absolute right-2 -bottom-8"
            src="data:image/png;base64,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"
            alt="Powered by Google"
          />
        )}
        <TypeIcon typeKey={type} type={type} className="h-6 w-6 mr-4 flex-none" />
        <div className="flex flex-wrap items-end">
          <p className="m-0 text-base flex flex-wrap items-end">
            <span className="pr-2">{title}</span>
            <span className=" flex-wrap font-thin text-gray-600 text-sm">{description}</span>
          </p>
        </div>
      </div>
    );
  }
}
